import React, { useEffect, useMemo, useState } from "react";
import { WebsiteController } from "../../../controllers";

const useContactUsLogic = () => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMessageModal, setViewMessageModal] = useState(false);

  const contactUsTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = WebsiteController.useGetContactUs(
    contactUsTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };
  const closeModal = () => {
    setViewMessageModal(false);
  };

  return {
    isLoading,
    data,
    isFetching,
    onLimitChange,
    limit,
    currentPage,
    setCurrentPage,
    searchQuery,
    setSearchQuery,
    closeModal,
    viewMessageModal,
    setViewMessageModal,
  };
};

export default useContactUsLogic;
